import classNames from "classnames";
import PropTypes from "prop-types";
import React, { Component } from "react";

import ChatActions from "../../../actions/ChatActions";
import SvgIcon from "../../common/SvgIcon";
import iconSprite from "../../../../../images/img/chat/icons.svg";

class CustomerReroutePromptBeforeClaimSystemMessage extends Component {
    constructor() {
        super();

        this.onRouteQuestion = this.onRouteQuestion.bind(this);
        this.onRouteQuestionKeyPress = this.onRouteQuestionKeyPress.bind(this);
    }

    onRouteQuestion(event) {
        ChatActions.reroute(this.props.question.uuid);
        event.preventDefault();
    }

    onRouteQuestionKeyPress(event) {
        if (event.charCode === 32 || event.charCode === 13) {
            this.onRouteQuestion(event);
        }
    }

    render() {
        const rerouteMessageClasses = classNames("system-message", "message-reroute-question", "reroute-prompt");

        return (
            <li>
                <div className={rerouteMessageClasses}>
                    <div className="icon icon-arrow-right">
                        <SvgIcon src={iconSprite} id="icon-arrow-right" />
                    </div>
                    <p className="body">
                        {`${i18n.t("rtm.text.route_your_question_to_company_part_1")} `}
                        <a onClick={this.onRouteQuestion} onKeyPress={this.onRouteQuestionKeyPress}>
                            <strong>{`${i18n.t("rtm.text.route_your_question_to_company_part_2")} `}</strong>
                        </a>
                        {i18n.t("rtm.text.route_your_question_to_company_part_3")}
                    </p>
                </div>
            </li>
        );
    }
}

CustomerReroutePromptBeforeClaimSystemMessage.propTypes = {
    question: PropTypes.objectOf(PropTypes.object).isRequired,
};

export default CustomerReroutePromptBeforeClaimSystemMessage;
